import { StyleSheet } from 'react-native'
import { Button, Dialog, Portal, Text, useTheme } from 'react-native-paper'
import { useDismissOnEscape } from '@/hooks/useDismissOnEscape'
import type { QuotaType } from '@/types/billing'

interface UpgradePromptProps {
    type: QuotaType
    visible: boolean
    onDismiss: () => void
    onUpgrade: () => void
}

export function UpgradePrompt({ type, visible, onDismiss, onUpgrade }: UpgradePromptProps) {
    const theme = useTheme()
    useDismissOnEscape(visible, onDismiss)

    const getTitle = () => {
        switch (type) {
            case 'team':
                return 'Team Member Limit Reached'
            case 'jobs':
                return 'Active Job Limit Reached'
            case 'customers':
                return 'Customer Limit Reached'
        }
    }

    const getMessage = () => {
        switch (type) {
            case 'team':
                return "You've reached your team member limit. Upgrade your plan to add more team members."
            case 'jobs':
                return "You've reached your active job limit. Upgrade your plan or complete existing jobs to add new ones."
            case 'customers':
                return "You've reached your customer limit. Upgrade your plan to add more customers."
        }
    }

    return (
        <Portal>
            <Dialog visible={visible} onDismiss={onDismiss}>
                <Dialog.Icon icon="alert-circle" color={theme.colors.primary} />
                <Dialog.Title style={styles.title}>{getTitle()}</Dialog.Title>
                <Dialog.Content>
                    <Text variant="bodyMedium" style={styles.message}>
                        {getMessage()}
                    </Text>
                </Dialog.Content>
                <Dialog.Actions style={styles.actions}>
                    <Button onPress={onDismiss}>Later</Button>
                    <Button mode="contained" onPress={onUpgrade}>
                        View Plans
                    </Button>
                </Dialog.Actions>
            </Dialog>
        </Portal>
    )
}

const styles = StyleSheet.create({
    title: {
        textAlign: 'center',
    },
    message: {
        textAlign: 'center',
    },
    actions: {
        justifyContent: 'center',
        gap: 8,
        paddingHorizontal: 16,
        paddingBottom: 16,
    },
})
